import {
  amber,
  blue,
  cyan,
  deepOrange,
  deepPurple,
  green,
  indigo,
  lime,
  orange,
  purple,
  red,
  teal,
  yellow,
} from '@mui/material/colors';

import type { ColorType } from '@components/ui/Avatar/Avatar.types';

export const baseColors = [
  red,
  green,
  blue,
  amber,
  cyan,
  deepOrange,
  lime,
  deepPurple,
  yellow,
  teal,
  indigo,
  orange,
  purple,
];

export const baseVariants = [
  200,
  300,
  400,
  500,
  600,
  700,
  800,
  900,
  'A100',
  'A200',
  'A400',
  'A700',
] as ColorType[];
